import type { Instrument } from "../data/instruments";

export class ResonanceLayer {
  connect(context: BaseAudioContext, input: AudioNode, destination: AudioNode, instrument: Instrument): AudioNode {
    const resonator = context.createBiquadFilter();
    const family = instrument.classification.family;

    resonator.type = "peaking";
    resonator.frequency.value =
      instrument.id === "gayageum"
        ? 430
        : instrument.id === "kora"
          ? 260
          : instrument.id === "mbira"
            ? 1850
            : family === "breathy_transverse_flute" || family === "breathy_end_blown_flute"
        ? 1800
        : family === "membrane_drum"
          ? 210
          : family === "bronze_idiophone"
            ? 980
            : 540;
    resonator.Q.value =
      instrument.id === "gayageum"
        ? 2.2
        : instrument.id === "kora"
          ? 1.4
          : family === "bronze_idiophone"
            ? 8
            : family === "membrane_drum"
              ? 3
              : 1.5;
    resonator.gain.value =
      instrument.id === "gayageum" || instrument.id === "kora" ? 3.4 : family === "bronze_idiophone" ? 4 : 2.5;

    input.connect(resonator);
    resonator.connect(destination);

    return resonator;
  }
}
